// TopPage.jsx
const TopPage = () => (
  <div className="top-page">
    <h1>Peronal Interests 👋</h1>
    <p>Summary | Contact | Testimonials</p>
  </div>
);
export default TopPage;
// This component is a simple functional component that renders a welcome message and some text.